import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'rn-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  standalone: true,
  imports: [MatTooltipModule],
})
export class ToggleSwitchComponent {
  @Input() labelText?: string;
  @Input() inputName: string;
  @Input() toggleModel: boolean;
  @Input() disabled: boolean = false;
  @Input() tooltipText?: string;
  @Output() toggleModelChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  // Controlled toggle: the native checkbox is always snapped back to the last
  // confirmed toggleModel value immediately, synchronously, regardless of what
  // the browser's default click behavior just did to its `checked` DOM property.
  // The parent is the sole source of truth and only a new toggleModel input
  // (e.g. after a successful registration call) actually flips the visible
  // state, so a pending or failed action never leaves the switch stuck "on".
  handleChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.checked = this.toggleModel;

    if (this.disabled) {
      return;
    }
    this.toggleModelChange.emit(!this.toggleModel);
  }
}
